import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ErrorService } from './error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
@Injectable({
    providedIn: 'root'
})
export class CommonHttpService extends Subject<DataStateChangeEventArgs> {
    constructor(public http: HttpClient, public errorService: ErrorService, private handler: HttpBackend) { super(); }


    /////////////////////////////////get state /////////////////////////////////////////////////////////////////////////

    getJSON(): Observable<any> {
        let httpLocal = new HttpClient(this.handler);
        return httpLocal.get("./assets/states.json");
    }

    ////////////////////////////getPayorDropDown////////////////////
    getPayorDropDown(paramsData: URLSearchParams): Observable<[{ Key: number, Value: string }]> {
        let url = "api/GroupPayor/CommonGetGPList?";
        return this.http.get<[{ Key: number, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    ////////////////////////////////////////getcompany////////////////////////////////
    getCompany(): Observable<[{ Key: string, Value: string }]> {
        let url = "api/Company/CommonGetCompanyList?";
        return this.http.get<[{ Key: string, Value: string }]>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    /////////////////////////////////getdclist///////////////////////////////////
    getDC(): Observable<[{ Key: number, Value: string }]> {
        let url = "api/Client/CommonGetDCList?";
        return this.http.get<[{ Key: number, Value: string }]>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    /////////////////////////////////////getlovdropdown////////////////////////////
    getStatus(paramsData: URLSearchParams): Observable<[{ Key: number, Value: string }]> {
        let url = "api/LOV/getLovDropDown?"
        return this.http.get<[{ Key: number, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    /////////////////////////////////////////getICD10////////////////////////////////////////
    getICD10(): Observable<[{ Key: number, Value: string }]> {
        let url = "api/Client/commonICDList"

        return this.http.get<[{ Key: number, Value: string }]>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    ////////////////////////////////////////getStartofCareListdate/////////////////////////
    getStartofCareListdate(params): Observable<any> {
        let url = "api/StartOfCare/GetStartOfCareDate?"
        return this.http.get<any>(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    getcompanyidofsoc(socId) {
        let url = "api/StartOfCare/GetCompanyofSoc?";
        let param = new URLSearchParams();
        param.append("socId", socId);
        return this.http.get<any>(url + param).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }

    GetAllEmployeesDropDownbyAgency(locId) {
        let url = "api/Employee/GetAllEmployeesDropDownbyAgency?";
        let params = new URLSearchParams();
        params.append("LocationId", locId);
        return this.http.get<any>(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }

    GetAllClientsDropDownbyAgency(locId): Observable<any> {
        let url = "api/Client/GetAllClientsDropDownbyAgency?";
        let params = new URLSearchParams();
        params.append("LocationId", locId);
        return this.http.get<any>(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }

    /////////////////////////////////get state /////////////////////////////////////////////////////////////////////////

    getFeaturesJSON(): Observable<any> {
        let httpLocal = new HttpClient(this.handler);
        return httpLocal.get("./assets/Features.json");
    }

    getpermission(paramsData: URLSearchParams): Observable<any> {
        let url = "api/FunctionPermission/getfunctionpermissionemployee?";
        return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    GetAllEmployeesDropdown(): Observable<any> {
        let url = "api/Employee/GetAllEmployeesDropdown?";
        return this.http.get<any>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }


    GetAllClientDropDown(): Observable<any> {
        let url = "api/Client/GetAllClientDropDown?";
        return this.http.get<any>(url, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    //.............................GetFunctionwithResponseTypeJson........................................
    GetFunctionwithResponseTypeJson(params, url): Observable<any> {
        return this.http.get(url + params, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }
    
    //.............................saveorUpdateFunctionwithResponseTypeJson........................................
    saveorUpdateFunctionwithResponseTypeJson(saveList, url): Observable<any> {
        return this.http.post(url, saveList, { observe: 'response' }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    saveorUpdateFunctionwithResponseTypeText(saveList, url): Observable<any> {
        return this.http.post(url, saveList, { observe: 'response', responseType: "text" }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }   

    GetFunctionwithResponseTypeText(params, url): Observable<any> {
        return this.http.get(url + params, { observe: 'response', responseType: "text" }).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        );
    }
    GetFunctionForResponseTypeAsBlob(params, url): Observable<any> {
        return this.http.get(url + params, { observe: 'response', responseType: 'blob' as 'arraybuffer' },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }


    DeleteFunctionForDeleteHttp(deleteList, url): Observable<any> {
        return this.http.delete(url + deleteList, { observe: 'response', responseType: "text" },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }

    public outputValues(url, List, responseData, params): void {
        this.GetCallForGridTable(url, List, responseData, params).subscribe((x) => super.next(x)
        );
    }
    //.............................GetCallForGridTable........................................
    GetCallForGridTable(url, List, responseData, params): Observable<DataStateChangeEventArgs> {
        return this.http.post<any>(url + params, List)
            .pipe(map(
                (response: any) =>
                    <any>{
                        result: response[responseData.result],
                        count: response[responseData.count],
                        sumOfTotalHours: response[responseData.sumOfTotalHours]
                    })).pipe(map((e: any) => {
                        return e;
                    }))
    }



    saveorUpdateFunctionResponseTypeAsBlob(data, url): Observable<any> {
        return this.http.post(url, data, { observe: 'response', responseType: 'blob' as 'arraybuffer' },).pipe(
            map(data => data.body),
            catchError(this.errorService.handleError)
        )
    }


}
